// extracted by mini-css-extract-plugin
module.exports = {"title":"PaymentLinkCancel_title__9yGGp","desc":"PaymentLinkCancel_desc__2Zq9_","prevPageBtn":"PaymentLinkCancel_prevPageBtn__Abe-E","footer":"PaymentLinkCancel_footer__3ebr-"};